import { createSlice } from "@reduxjs/toolkit";
import {
  getContactSettings,
  createContactSettings,
  updateContactSettings,
} from "actions/contactSettings";

const initialState = {
  loading: false,
  updateLoading: false,
  settings: null,
  settingsExist: false,
  error: null,
};

export const contactSettingsSlice = createSlice({
  name: "contactSettings",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getContactSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContactSettings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.settings = payload;
        // receiverEmail is only present in the response when a settings row exists.
        // When no row has been created yet the backend returns all-null fields
        // without receiverEmail, so we use its presence as the existence flag.
        state.settingsExist = payload !== null && "receiverEmail" in payload;
      })
      .addCase(getContactSettings.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(createContactSettings.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(createContactSettings.fulfilled, (state, { payload }) => {
        state.updateLoading = false;
        state.settings = payload;
        state.settingsExist = true;
      })
      .addCase(createContactSettings.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });

    builder
      .addCase(updateContactSettings.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateContactSettings.fulfilled, (state, { payload }) => {
        state.updateLoading = false;
        state.settings = payload;
        state.settingsExist = true;
      })
      .addCase(updateContactSettings.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });
  },
});

export const { clearError } = contactSettingsSlice.actions;

export default contactSettingsSlice.reducer;
